module.exports = __webpack_public_path__ + "static/media/backward.4cfa0df1.svg";